import { formatNumberValue } from '../../components/ideaNiv/Funcs';

/** Format a single idea-info-tab property value for read-only display. */
export function formatConfigFieldValue(
  raw: unknown,
  property: { prefix?: string }
): string | null {
  if (raw === undefined || raw === null || raw === '') {
    return 'N/A';
  }
  if (typeof raw === 'number') {
    return formatNumberValue(raw, property.prefix);
  }
  if (typeof raw === 'boolean') {
    return raw ? 'Yes' : 'No';
  }
  if (typeof raw === 'object') {
    return null;
  }
  return String(raw);
}
